<template>
  <div class="wrapper">
    <base-bread-crumb :currBreadCrumb="currBreadCrumb"></base-bread-crumb>
    <div class="ccui-home-app-container-detail">
      <div class="ccui-app-container">
        <div class="applicate-communicate">
          <div class="title">
            <el-row>
              <el-col :span="20"
                ><div class="grid-content bg-purple">
                  {{ introductionObj.columnName }}
                </div></el-col
              >
              <el-col :span="4"
                ><div
                  :title="introductionObj.administratorNamesStr"
                  class="administrator grid-content bg-purple-light"
                >
                  管理员：{{ introductionObj.administratorNamesStr }}
                </div></el-col
              >
            </el-row>
          </div>
          <div class="content">
            <el-row>
              <el-col :span="20"
                ><div class="system-info">
                  <div>
                    <span style="color: #0189ef">系统介绍：</span>
                    <span>
                      {{ introductionObj.introductory }}
                    </span>
                  </div>
                  <div class="remarks">
                    [<span>{{ introductionObj.themeCount }}</span
                    >主题/<span>{{ introductionObj.replyCount }}</span
                    >回复]
                  </div>
                </div>
              </el-col>

              <el-col :span="4">
                <div class="posting-btn">
                  <el-button type="primary" @click="postingBtn">发帖</el-button>
                </div></el-col
              >
            </el-row>
          </div>
        </div>
      </div>
      <div class="ccui-app-container-tow">
        <el-table
          :data="tableData"
          style="width: 1180px"
          height="450"
          :header-cell-style="{
            background: '#e3eef6',
            color: '#048bef'
          }"
        >
          <el-table-column
            prop="themeName"
            label="主题"
            show-overflow-tooltip
            width="380"
          >
            <template slot-scope="scope">
              <div @click="titleHandle(scope.row)" class="cell-ellipsis">
                <span class="essence" v-if="scope.row.themeIsQuintessence == 1"
                  >精</span
                >
                <span class="Topping" v-if="scope.row.themeIsTop == 1"
                  >置顶</span
                >
                <!-- <el-tooltip class="item" effect="dark" :content="scope.row.content" placement="left"> -->
                {{ scope.row.themeName }}
                <!-- </el-tooltip> -->
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="createName" label="作者" width="100">
          </el-table-column>
          <el-table-column prop="createTime" label="时间" width="200">
            <template slot-scope="scope">
              <div>{{ scope.row.createTime }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="replyCount" label="回复/查看" width="150">
            <template slot-scope="scope">
              <div style=" font-size: 13px;">
                <span style="color:#0089EF">{{ scope.row.replyCount }}</span
                >/{{ scope.row.viewCount }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="lastReplyName" label="回复人" width="150">
          </el-table-column>
          <el-table-column
            prop="lastReplyTime"
            label="最后回复时间"
            width="200"
          >
          </el-table-column>
        </el-table>
        <div class="ccui-table-footer">
          <div id="ccui-paging">
            <el-pagination
              :total="pageTotal"
              :page-size="pageSize"
              :current-page="pageNo"
              :page-sizes="[10, 20, 50, 100, 200, 500]"
              background
              layout="total, sizes, prev, pager, next, jumper"
              popper-class="ccui-paging-page-size-popper"
              @prev-click="handlePrev"
              @next-click="handleNext"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
            />
            <el-button
              class="ccui-pagination-btn"
              size="mini"
              type="default"
              @click="handleSizeChange('none')"
              >确定</el-button
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mixinListCommon } from "@/mixins/mixin-common/mixin-list";
import baseBreadCrumb from "@/app/shop/components/baseBreadCrumb.vue";
import { qryThemePage, addViewCount } from "@/app/shop/api/shopping";
export default {
  name: "plateTitle",
  mixins: [mixinListCommon],
  components: {
    baseBreadCrumb
  },
  props: {
    source: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      currBreadCrumb: [{ title: "论坛" }],
      tableData: [],
      introductionObj: this.$route.query,
      pageTotal: 0,
      pageSize: 10,
      pageNo: 1
    };
  },
  activated() {
    this.getList();
    console.log(this.introductionObj, "introductionObj");
  },
  deactivated() {},
  methods: {
    getList(val) {
      let params = {
        businessId: this.$route.query.businessId,
        pageNo: val || 1,
        pageSize: 10,
        isShowLoading: true
      };
      qryThemePage(params).then(res => {
        if (res.data.code == "0") {
          console.log(res.data.data);
          this.tableData = res.data.data.rows;
          // this.tableData = resObj.rows
          this.pageNo = res.data.data.pageNo;
          this.pageTotal = res.data.data.recordsTotal;
          console.log(this.tableData, "tableData");
        }
      });
    },
    titleHandle(row) {
      let params = {
        businessId: row.themeId,
        isShowLoading: true
      };
      addViewCount(params).then(res => {
        if (res.data.code == "0") {
          this.$router.push({
            path: "/themeDetails",
            query: {
              themeId: row.themeId,
              themeIsQuintessence: row.themeIsQuintessence,
              themeIsTop: row.themeIsTop,
              themeClose: row.themeClose,
              activeIndex: this.$route.query.activeIndex
            }
          });
        }
      });
    },
    postingBtn() {
      this.$router.push({
        path: "/postingAdd",
        query: {
          columnId: this.$route.query.businessId,
          type: "add",
          activeIndex: this.$route.query.activeIndex
        }
      });
    },
    handlePrev() {
      //   --this.pageNo;
      //   let obj = {
      //     pageNo: this.pageNo,
      //     pageSize: this.pageSize
      //   };
      //   // this.getList(obj);
    },
    handleNext() {
      //   ++this.pageNo;
      //   let obj = {
      //     pageNo: this.pageNo,
      //     pageSize: this.pageSize
      //   };
      //   // this.getList(obj);
    },
    handleSizeChange(val) {
      //   this.pageNo = 1;
      //   if (val !== "none") {
      //     this.pageSize = val;
      //     // setSessionItem("pageSize", this.tableName, val);
      //   }
      //   let obj = {
      //     pageNo: this.pageNo,
      //     pageSize: this.pageSize
      //   };
      //   // this.getList(obj);
    },
    handleCurrentChange(val) {
      this.getList(val);
    }
  }
};
</script>

<style scoped lang="scss">
/* 为Element UI的Table组件修改滚动条颜色 */
::v-deep .el-table__body-wrapper::-webkit-scrollbar {
  width: 12px; /* 设置滚动条宽度 */
}

::v-deep .el-table__body-wrapper::-webkit-scrollbar-track {
  background: #ffffff; /* 滚动条轨道颜色 */
}

::v-deep .el-table__body-wrapper::-webkit-scrollbar-thumb {
  background: #9e9e9e; /* 滚动条手柄颜色 */
}

::v-deep .el-table__body-wrapper::-webkit-scrollbar-thumb:hover {
  background: #5f5f5f; /* 滚动条手柄hover颜色 */
}
::v-deep .el-tooltip {
  width: 320px !important;
}
.administrator {
  white-space: nowrap; /* 确保文本在一行内显示 */
  overflow: hidden; /* 隐藏超出容器的内容 */
  text-overflow: ellipsis; /* 使用省略号表示被截断的文本 */
  width: 100%; /* 设置容器宽度 */
  max-width: 250px; /* 可选：设置最大宽度，防止过度缩小 */
  /* 其他样式 */
}
.ccui-home-app-container-detail {
  margin: 0 auto 20px !important;
}
.cell-ellipsis {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  cursor: pointer;
}
.cell-ellipsis:hover {
  color: #0089ef;
}

.ccui-app-container {
  min-height: 160px;
  padding: 0px !important;
}
.ccui-app-container-tow {
  min-height: 515px;
  background-color: #fff;
  padding-bottom: 20px;
  position: relative;
  .ccui-table-footer {
    // position: absolute;
    //   left: 60%;
    //   bottom: 40px;
    text-align: right;
    margin: 30px 17px 30px 0;
  }
  .essence {
    display: inline-block;
    width: 24px;
    height: 18px;
    background: #ff142f;
    border-radius: 2px;
    font-size: 12px;
    color: #ffffff;
    line-height: 18px;
    text-align: center;
    margin-right: 5px;
  }
  .Topping {
    display: inline-block;
    width: 38px;
    height: 18px;
    background: #0089ef;
    border-radius: 2px;
    font-size: 12px;
    color: #ffffff;
    line-height: 18px;
    text-align: center;
  }
}
.title {
  background-color: rgb(227, 238, 246) !important;
  color: #0189ef;
  font-weight: bold;
  font-size: 14px;
  padding: 10px 50px;
}
.content {
  font-size: 14px;
  padding: 10px 50px;
  .system-info {
    margin-right: 30px;
    padding-right: 20px;
    border-right: 1px dashed #ccc;
    min-height: 98px;
    .remarks {
      margin-top: 45px;
    }
  }
  .posting-btn {
    margin-top: 33px;
    /deep/ .el-button--primary {
      width: 85px !important;
    }
  }
}
/deep/ .el-table td {
  padding: 10px 10px 10px 0 !important;
}
/deep/ .el-table td:nth-child(1) {
  padding-left: 40px !important;
}
/deep/ .el-table th:nth-child(1) {
  padding-left: 40px !important;
}
</style>
